export type Ration = 'Filling' | 'Meager' | 'Bare Bones';
export const ALL_RATIONS: Ration[] = ['Filling', 'Meager', 'Bare Bones'];
